import axios from 'axios/index';
import config from './config.js';
import cookieOperation from './cookieOperation.js';
export default {
    /**
     * 公共HTTP POST 请求
     * @param url
     * @param param
     * @param callback
     */
    publicget: function (url, param, callback, ip) {
        if (ip === undefined || ip === '') {
            ip = config.service_ip;
        }
        let accessToken = cookieOperation.cookie.get('access_token');
        // let accessToken = 'e67ee919bf134b308ed822e37c83d1e0';
        if (accessToken) {
            axios.post(ip + url, param).then(res => {
                callback(res.data);
            }, err => {
                if (err.status === 200) {
                    callback(err.data);
                } else {
                    let res = {
                        success: false,
                        msg: '服务器繁忙！'
                    };
                    callback(res);
                }
            });
        } else {
            top.location.href = config.login_ip;
        }
    },
    publicLogin: function (url, param, callback, ip) {
        if (ip === undefined || ip === '') {
            ip = config.service_ip;
        }
        axios.post(ip + url, param).then(res => {
            callback(res.data);
        }, err => {
            if (err.status === 200) {
                callback(err.data);
            } else {
                let res = {
                    success: false,
                    msg: err
                };
                callback(res);
            }
        });
    },
    // 获取当前日期
    getNowTime() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var date = now.getDate();
        month = month + 1;
        month = month.toString().padStart(2, '0');
        date = date.toString().padStart(2, '0');
        var defaultDate = `${year}-${month}-${date}`;
        return defaultDate;
    },
    // 参数获取
    getParam(sel) {
        let zjbh, khbh, khmc;
        if (sessionStorage.getItem(sel)) {
            // console.log(JSON.parse(sessionStorage.getItem(sel)));
            return {
                khmc: JSON.parse(sessionStorage.getItem(sel)).khmc,
                zjbh: JSON.parse(sessionStorage.getItem(sel)).zjhm,
                khbh: JSON.parse(sessionStorage.getItem(sel)).khbh
            };
        } else {
            return {
                zjbh: null,
                khbh: null
            };
        }
    },
    sleep(time = 0) {
        return new Promise((resolve, reject)=> {
            setTimeout(() => {
                resolve();
            }, time);
        });
    },
    /**
     * 转换字典
     * @param json 字典
     * @param key 需要转换的值
     * @returns {*}
     */
    formatDict: function (json, key) {
        for (let i = 0; i < json.length; i++) {
            let name = json[i].name;
            if (key === name) {
                return json[i].des;
            }
        }
        return '';
    },
    /**
     * 日期格式校验
     * @param {日期字符串} text
     * @param {*} callback
     */
    checkDate: function (text) {
        const dateregex = /^\d{4}-\d{2}-\d{2}$/;
        if (text === undefined || text === null || text === '') {
            return false;
            // callback(new Error('日期不能为空'));
        } else if (!dateregex.test(text)) {
            return false;
            // callback(new Error('您输入的日期格式不正确！例如：2022-01-01'));
        } else {
            return true;
        }
    },
    /**
     * 是否为空
     * @param text
     * @returns {boolean}
     */
    isEmpty: function (text) {
        if (text === undefined || text === null || text === '') {
            return true;
        }
        return false;
    },
    /**
     * 根据编码展示地址名称
     * @param item
     * @param data
     * @returns {*}
     */
    loadadds: function (item, data) {
        for (var i = 0; i < data.length; i++) {
            if (data[i].id === item) {
                // console.log(data[i].fullName);
                return data[i].fullName;
            }
        }
    },
    getQueryStringByName: function (name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        var context = '';
        if (r != null) {
            context = r[2];
        }
        reg = null;
        r = null;
        return context == null || context === '' || context === 'undefined' ? '' : context;
    },
    formatDate: {
        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length === matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);
                            break;
                        case 'M':
                            _date.setMonth(_int - 1);
                            break;
                        case 'd':
                            _date.setDate(_int);
                            break;
                        case 'h':
                            _date.setHours(_int);
                            break;
                        case 'm':
                            _date.setMinutes(_int);
                            break;
                        case 's':
                            _date.setSeconds(_int);
                            break;
                    }
                }
                return _date;
            }
            return null;
        }
    },
    /**
     * 省,市,县,街道 四级联动
     * @param name
     * @param key
     * @param _this
     */
    addressChange: function (name, key, _this) {
        // console.log(name)
        // console.log(key)
        // console.log(_this)
        if (key === null || key === '') {
            return;
        }
        this.publicpost('/regionalAddress/selectSubordinateRegionalAddressList', {
            partentId: key
        }, function (res) {
            if (res.code === 0) {
                _this[name] = res.data;
            } else {
                _this.$message({
                    showClose: true,
                    message: '获取失败',
                    type: 'error'
                });
            }
            _this.editLoading = false;
        });
    },

    /**
     * 区划信息回写
     * @param _this
     * @param name
     * @param id
     * @param fullName
     */
    formatAddress: function (_this, name, id, fullName) {
        if (id === null || id === '') {
            return;
        }
        if (name === null || name === '') {
            return;
        }
        const list = _this[name];
        let flag = 'true';
        list.forEach(function (item) {
            if (id === item.id) {
                flag = 'false';
            }
        });
        if (flag === 'true') {
            let map = {'id': id, 'fullName': fullName};
            _this[name].push(map);
        }
    },
    /**
     * 将字段的大写字母转换成下划线加小写字母
     * @param str
     * @returns {*}
     * @constructor
     */
    dtotoLower: function (str) {
        str = str.replace(/[A-Z]/g, function (ch) {
            return '_' + String.fromCharCode(ch.charCodeAt(0) | 32);
        });
        return str;
    },
    /**
     * 截取asc或desc
     * @param str
     * @returns {string}
     */
    dtopx: function (str) {
        if (str.startsWith('a')) {
            return str.substring(0, 3);
        } else {
            return str.substring(0, 4);
        }
    },
    /**
     * 中文验证
     */
    isChinese: function(str) {
        const reg = /[\u4e00-\u9fa5]/;
        return reg.test(str);
    },

    /**
     * 验证手机号
     */
    isvalidPhone: function (rule, value, callback, whether) {
        const reg = /^[1][0-9][0-9]{9}$/;
        if (whether === 'required') {
            if (!value) {
                callback(new Error('请输入手机号码'));
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的11位手机号码'));
            } else {
                callback();
            }
        } else {
            if (!value) {
                callback(new Error('请输入手机号码'));
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的11位手机号码'));
            } else {
                callback();
            }
        }
    },
    /**
     * 验证手机号
     */
    isvalidPhoneTo: function (letter) {
        const reg = /^[1][0-9][0-9]{9}$/;
        return reg.test(letter);
    },
    /**
     * 验证固定电话、手机号
     */
    isvalidGDPhoneTo: function (letter) {
        const reg = /^((0\d{2,3}\d{7,8})|(1[0-9][0-9]{9}))$/;
        return reg.test(letter);
    },
    /**
     * 验证密码规则 包含数字字母
     */
    passwordValid: function(password) {
        let isDigit = /^.*[0-9]+.*/;
        let isLower = /^.*[a-zA-Z]+.*/;
        // let isUpper = /^.*[A-Z]+.*/;
        // let regEx = /^.*[^0-9a-zA-Z]+.*/;
        let num = 0;
        if (isDigit.test(password)) {
            num = num + 1;
        }
        if (isLower.test(password)) {
            num = num + 1;
        }
        // if (isUpper.test(password)) {
        //    num = num + 1;
        // }
        return num;
    },
    /**
     * 统一信用代码
     * @param {*} str
     */
    isCredit: function(str) {
        let isDigit = /[0-9A-Z]{18}/;
        return isDigit.test(str);
    },

    /**
     * 邮箱验证
     */
    isEmail: function(email) {
        return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(email);
    },

    /**
     * 邮箱验证
     */
    isNumber: function(info) {
        return /^(\d+)$|(\d+\.\d+)$|^[-]{0,1}(\d+)$|^[-]{0,1}(\d+\.\d+)$/.test(info);
    },

    /**
     * 是否有特殊字符
     */
    stripscript: function (rule, value, callback) {
        /* let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
        let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
        // let reg = /^[0-9a-zA-Z]*$/g;
        if (regEn.test(value) || regCn.test(value)) {
            callback(new Error('您输入的信息不匹配！'));
        } else {
            callback();
        } */
        // return rs;
    },
    // 行内编辑——是否含有特殊字符
    stripscriptrow: function (value) {
        /* let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
        let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
        if (regEn.test(value) || regCn.test(value)) {
            return true;
        } else {
            return false;
        } */
    },
    /**
     * 验证url
     */
    IsURL: function (rule, value, callback) {
        let strRegex = '\\b(([\\w-]+://?|www[.])[^\\s()<>]+(?:\\([\\w\\d]+\\)|([^[:punct:]\\s]|/)))';
        let re = new RegExp(strRegex);
        if (!value) {
        } else if (!re.test(value)) {
            callback(new Error('您输入的url不匹配'));
        } else {
            callback();
        }
    },
    /**
     * 验证身份证
     */
    identityCard: function (identityCard) {
        const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
        return reg.test(identityCard);
    },
    /**
     * 验证只能输入数字，字母，或者数字字母组合
     */
    numberLetter: function (letter) {
        const reg = /^[0-9a-zA-Z]*$/g;
        return reg.test(letter);
    },
    /**
     * 验证只能输入文字
     */
    verificationChinese: function (chinesestr) {
        const reg = /^[\u2E80-\u9FFF]+$/;
        return reg.test(chinesestr);
    },
    /**
     *  校验邮编,不带提示信息
     * @param chinesestr
     * @returns {boolean}
     */
    validPostcode: function (chinesestr) {
        const reg = /^[0-9][0-9]{5}$/;
        return reg.test(chinesestr);
    },
    /**
     * 验证邮编
     */
    isPostalCode: function (rule, value, callback, whether) {
        const reg = /^[0-9][0-9]{5}$/;
        console.log(whether);
        if (whether === 'required') {
            if (!value) {
                callback(new Error('请输入邮编号码'));
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的6位邮编号码'));
            } else {
                callback();
            }
        } else {
            if (!value) {
                callback(new Error('请输入邮编号码'));
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的6位邮编号码'));
            } else {
                callback();
            }
        }
        // return reg.test(text);
    },
    /*
    * 验证只能输入数字或字符
    * */
    validCode: function (rule, value, callback) {
        /* let reg = /^[0-9a-zA-Z]*$/g;
        let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
        let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
        if (!reg.test(value) || regEn.test(value) || regCn.test(value)) {
            callback(new Error('只能输入数字或字符'));
        } else {
            callback();
        } */
    },
    /**
     * 验证只邮箱行内的编辑
     */
    isPostalCodeTo: function (letter) {
        const reg = /^[0-9][0-9]{5}$/;
        return reg.test(letter);
    },
    /**
     * 验证只能输入数字并且是>0的数字
     */
    verifyFigure: function (figure) {
        const reg = /^[0-9]\d*(\.\d+)?$/;
        return reg.test(figure);
    },
    /**
     * 五级联动 选择清空
     */
    PyatyiLinkage: function (name, _this, Form) {
        if (Form === 'add') {
            if (name === 'addressed') {
                _this.addForm.provinceId = '';
                _this.addForm.cityId = '';
                _this.addForm.districtId = '';
                _this.addForm.streetId = '';

                _this.addForm.provinceName = '';
                _this.addForm.cityName = '';
                _this.addForm.districtName = '';
                _this.addForm.streetName = '';

                _this.addressed = [];
                _this.city = [];
                _this.county = [];
                _this.street = [];
            } else if (name === 'city') {
                _this.addForm.cityId = '';
                _this.addForm.districtId = '';
                _this.addForm.streetId = '';
                _this.addForm.cityName = '';
                _this.addForm.districtName = '';
                _this.addForm.streetName = '';

                _this.city = [];
                _this.county = [];
                _this.street = [];
            } else if (name === 'county') {
                _this.addForm.districtId = '';
                _this.addForm.streetId = '';
                _this.addForm.districtName = '';
                _this.addForm.streetName = '';
                _this.county = [];
                _this.street = [];
            } else {
                _this.addForm.streetId = '';
                _this.addForm.streetName = '';

                _this.street = [];
            }
        } else {
            if (name === 'addressed') {
                _this.addForm.provinceId = '';
                _this.addForm.cityId = '';
                _this.addForm.districtId = '';
                _this.addForm.streetId = '';

                _this.addForm.provinceName = '';
                _this.addForm.cityName = '';
                _this.addForm.districtName = '';
                _this.addForm.streetName = '';

                _this.editForm.provinceId = '';
                _this.editForm.cityId = '';
                _this.editForm.districtId = '';
                _this.editForm.streetId = '';

                _this.editForm.provinceName = '';
                _this.editForm.cityName = '';
                _this.editForm.districtName = '';
                _this.editForm.streetName = '';

                _this.addressed = [];
                _this.city = [];
                _this.county = [];
                _this.street = [];
            } else if (name === 'city') {
                _this.addForm.cityId = '';
                _this.addForm.districtId = '';
                _this.addForm.streetId = '';
                _this.addForm.cityName = '';
                _this.addForm.districtName = '';
                _this.addForm.streetName = '';

                _this.editForm.cityId = '';
                _this.editForm.districtId = '';
                _this.editForm.streetId = '';
                _this.editForm.cityName = '';
                _this.editForm.districtName = '';
                _this.editForm.streetName = '';
                _this.city = [];
                _this.county = [];
                _this.street = [];
            } else if (name === 'county') {
                _this.addForm.districtId = '';
                _this.addForm.streetId = '';
                _this.addForm.districtName = '';
                _this.addForm.streetName = '';

                _this.editForm.districtId = '';
                _this.editForm.streetId = '';
                _this.editForm.districtName = '';
                _this.editForm.streetName = '';
                _this.county = [];
                _this.street = [];
            } else {
                _this.addForm.streetId = '';
                _this.addForm.streetName = '';

                _this.editForm.streetId = '';
                _this.editForm.streetName = '';
                _this.street = [];
            }
        }
    }
};

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
    var leng = len - (s + '').length;
    for (var i = 0; i < leng; i++) {
        s = '0' + s;
    }
    return s;
}



// WEBPACK FOOTER //
// ./src/common/js/util.js